import { Link } from "@mui/material";
import { StoreBadgeImage } from "Components/MobileApp/MobileAppInstallBanner/StoreBadgeImage";

type Props = {
  href: string;
  imageSrc: string;
  alt: string;
};

export const StoreBadgeLink = ({ href, imageSrc, alt }: Props) => (
  <Link href={href} target="_blank" rel="noopener noreferrer">
    <StoreBadgeImage imageSrc={imageSrc} alt={alt} />
  </Link>
);
